import React, { useState, useEffect } from 'react';

const FloatingSocialButtons = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // Afficher les boutons après un petit délai
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Masquer/afficher selon le scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const socialLinks = [
    {
      name: 'WhatsApp',
      url: 'https://wa.me/33645219585',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516"/>
        </svg>
      ),
      color: '#25D366',
      hoverColor: '#128C7E'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@ChristopheD%C3%A9panne',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      color: '#FF0000',
      hoverColor: '#CC0000'
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@christophedepanne',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
        </svg>
      ),
      color: '#000000',
      hoverColor: '#333333'
    },
    {
      name: 'Téléphone',
      url: 'tel:+33645219585',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
        </svg>
      ),
      color: '#007bff',
      hoverColor: '#0056b3'
    }
  ];

  return (
    <div className={`floating-social-container ${isVisible ? 'visible' : ''}`}>
      {/* Bouton principal */}
      <button
        className={`floating-main-btn ${isExpanded ? 'expanded' : ''}`}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label="Ouvrir les réseaux sociaux"
      >
        <span className={`main-icon ${isExpanded ? 'rotated' : ''}`}>
          {isExpanded ? (
            <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          )}
        </span>
      </button>

      {/* Boutons des réseaux sociaux */}
      <div className={`floating-buttons-list ${isExpanded ? 'expanded' : ''}`}>
        {socialLinks.map((social, index) => (
          <a
            key={social.name}
            href={social.url}
            target={social.name === 'Téléphone' ? '_self' : '_blank'}
            rel={social.name === 'Téléphone' ? '' : 'noopener noreferrer'}
            className="floating-social-btn"
            style={{
              '--btn-color': social.color,
              '--btn-hover-color': social.hoverColor,
              '--delay': `${index * 0.1}s`
            }}
            aria-label={social.name}
          >
            <span className="social-icon">{social.icon}</span>
            <span className="social-label">{social.name}</span>
          </a>
        ))}
      </div>

      {/* Overlay pour fermer sur mobile */}
      {isExpanded && (
        <div 
          className="floating-overlay"
          onClick={() => setIsExpanded(false)}
        />
      )}

      <style jsx>{`
        .floating-social-container {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
          opacity: 0;
          transform: translateY(100px);
          transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }

        .floating-social-container.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .floating-main-btn {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.4);
          transition: all 0.3s ease;
          position: relative;
          z-index: 1001;
        }

        .floating-main-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 12px 35px rgba(0, 123, 255, 0.6);
        }

        .floating-main-btn.expanded {
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
          box-shadow: 0 8px 25px rgba(220, 53, 69, 0.4);
        }

        .main-icon {
          font-size: 24px;
          transition: all 0.3s ease;
          display: block;
        }

        .main-icon.rotated {
          transform: rotate(180deg);
        }

        .floating-buttons-list {
          position: absolute;
          bottom: 70px;
          right: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }

        .floating-buttons-list.expanded {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .floating-social-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 50px;
          background: var(--btn-color);
          color: white;
          text-decoration: none;
          border-radius: 50%;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
          transform: translateX(100px);
          opacity: 0;
          position: relative;
          overflow: hidden;
        }

        .floating-buttons-list.expanded .floating-social-btn {
          transform: translateX(0);
          opacity: 1;
          animation: slideInRight 0.5s ease var(--delay) both;
        }

        .floating-social-btn:hover {
          background: var(--btn-hover-color);
          transform: translateX(-10px) scale(1.1);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
        }

        .social-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
        }

        .social-label {
          position: absolute;
          right: 60px;
          background: rgba(0, 0, 0, 0.8);
          color: white;
          padding: 8px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          opacity: 0;
          transform: translateX(10px);
          transition: all 0.3s ease;
          pointer-events: none;
          z-index: 1002;
        }

        .floating-social-btn:hover .social-label {
          opacity: 1;
          transform: translateX(0);
        }

        .floating-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: transparent;
          z-index: 999;
        }

        @keyframes slideInRight {
          from {
            transform: translateX(100px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        /* Animations de pulsation pour attirer l'attention */
        @keyframes pulse {
          0% {
            box-shadow: 0 8px 25px rgba(0, 123, 255, 0.4);
          }
          50% {
            box-shadow: 0 8px 25px rgba(0, 123, 255, 0.8);
          }
          100% {
            box-shadow: 0 8px 25px rgba(0, 123, 255, 0.4);
          }
        }

        .floating-main-btn:not(.expanded) {
          animation: pulse 2s infinite;
        }

        @media (max-width: 768px) {
          .floating-social-container {
            display: none !important;
          }
        }

        /* Animation d'entrée pour les boutons individuels */
        .floating-social-btn:nth-child(1) { --delay: 0.1s; }
        .floating-social-btn:nth-child(2) { --delay: 0.2s; }
        .floating-social-btn:nth-child(3) { --delay: 0.3s; }
        .floating-social-btn:nth-child(4) { --delay: 0.4s; }
      `}</style>
    </div>
  );
};

export default FloatingSocialButtons;
